import { BrowserLanguage, BrowserLanguageAction, SET_BROWSER_LANGUAGE } from './types';

export function setBrowserLanguage(browserLanguage: BrowserLanguage): BrowserLanguageAction {
	return {
		type: SET_BROWSER_LANGUAGE,
		payload: browserLanguage,
	};
}
